import { 
    SET_ASKED_FOR_CONTACT_LIST,
    SET_LOADING,
    SET_PROFILE_DATA,
    SET_PROFILE_METADATA,
    SET_RECEIVED_CONTACT_LIST,
} from "../../actions/profile/types";

const INITIAL_STATE = {
    loading: false,
    profileData: [],
    profileMetaData: null,
    receivedContactList: [],
    askedForContactList: []
}

const ProfileReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_PROFILE_DATA: {
            return {
                ...state,
                profileData : action.payload
            }
        }
        case SET_PROFILE_METADATA: {
            return {
                ...state,
                profileMetaData : action.payload
            }
        }
        case SET_LOADING: {
            return {
                ...state,
                loading: action.payload
            }
        }
        case SET_RECEIVED_CONTACT_LIST: {
            return {
                ...state,
                receivedContactList : action.payload
            }
        }
        case SET_ASKED_FOR_CONTACT_LIST: {
            return {
                ...state,
                askedForContactList : action.payload
            }
        }
        default: {
            return state;
        }
    }
}

export default ProfileReducer;